import script from "./History.vue?vue&type=script&setup=true&lang=ts"
export * from "./History.vue?vue&type=script&setup=true&lang=ts"

import "./History.vue?vue&type=style&index=0&id=68e33fd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e33fd4"]])

export default __exports__